import { render, staticRenderFns } from "./CourseSelect.vue?vue&type=template&id=54dc4aa8"
import script from "./CourseSelect.vue?vue&type=script&lang=js"
export * from "./CourseSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports